import axios from "axios";
import UidEmailRoleMatch from "../../../constants/uidEmailRoleMatch";
export const fetchHeaderRecord = (
  customerId: number,
  sessionid: string | null
) => {
  const UidEmailRole = UidEmailRoleMatch();

  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/one/tradexwbench.customer/${customerId}`,
      {
        params: {
          ...UidEmailRole,
          filter: "[]",
          query:
            "{stage,application_uid, customer_contact_name, customer_contact_mobile, designation, customer_contact_email, business_participant_type, business_registration_country_id{name}, business_gst, business_tanno,business_name,  business_constitution_type, is_counterparty, customer_contact_mobile_country_code, business_tax_identification_number}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    )
    .then((response) => {
      // // console.warn("in api call", response);
      return response;
    })
    .catch((err) => err);
};
